import { Trans } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './ApplicationLoader.module.css';
import { useGetStateQuery } from '../../api/lendingApi/lendingApiQueries';
import { useLocale } from '../../hooks/useLocale';
import { useSignupParams } from '../../hooks/useSignupParams';
import MarketingPoll from '../MarketingPoll/MarketingPoll';
import Spinner from '../Spinner/Spinner';

const ApplicationLoader = () => {
  const { isDirectCustomer } = useSignupParams();
  const { isUK } = useLocale();
  const { state } = useGetStateQuery();

  const hasPollAnswer =
    state?.application?.people?.[0].how_did_you_find_us?.answer;

  return (
    <div className={clsx(styles.container, styles.loadingContainer)}>
      <h1 className={styles.loadingHeading}>
        <Trans>We’re checking your application...</Trans>
      </h1>
      <h2 className={styles.loadingSubHeading}>
        <Trans>This may take up to 60 seconds</Trans>
      </h2>
      <div className={styles.spinnerContainer}>
        <Spinner />
      </div>

      {isDirectCustomer && isUK && !hasPollAnswer && (
        <>
          <hr />
          <MarketingPoll />
        </>
      )}
    </div>
  );
};

export default ApplicationLoader;
